import type { ReactNode } from "react";
import type { DataTableColumn } from "./DataTable";

const DEFAULT_ACTIONS_WIDTH = 96;

const ALIGN_TEXT_CLASS = {
  left: "text-left",
  center: "text-center",
  right: "text-right",
} as const;

/**
 * Trailing column for row-level controls (edit/delete buttons, menus, etc.).
 * For navigable rows, prefer `onRowClick` on `DataTable` instead of a chevron-only column.
 */
export function createActionsColumn<T, SortKey extends string = string>(
  header: string,
  options: {
    cell: (row: T) => ReactNode;
    defaultWidth?: number;
    minWidth?: number;
    /** Defaults to `"center"`. */
    align?: "left" | "center" | "right";
    cellClassName?: string;
  },
): DataTableColumn<T, SortKey> {
  const defaultWidth = options.defaultWidth ?? DEFAULT_ACTIONS_WIDTH;
  const minWidth = options.minWidth ?? defaultWidth;
  const align = options.align ?? "center";
  const alignTextClass = ALIGN_TEXT_CLASS[align];

  return {
    id: "actions",
    header,
    align,
    defaultWidth,
    minWidth,
    resizable: false,
    alwaysVisible: true,
    pinRight: true,
    headerClassName: `px-3 ${alignTextClass}`,
    cellClassName: options.cellClassName ?? `px-3 ${alignTextClass}`,
    cell: options.cell,
  };
}
